import webSocketStateQuery from "../websocket/useStateQuery";
import httpStateQuery from "../services/stateQuery";
import usePing from "../websocket/usePing";
import { useEffect, useRef, useState } from "react";

const useStateQuery = (cryptoPair, klineInterval) => {
  const { liveResult: webSocketResult, shouldUseWebSocket } = webSocketStateQuery(
    cryptoPair?.toUpperCase(),
    klineInterval.websocket
  );
  const { shouldUseWebSocket: pingPong } = usePing();
  const [result, setResult] = useState({ time: 0 });

  let interval = useRef(null);

  useEffect(() => {
    if (pingPong && shouldUseWebSocket) {
      clearInterval(interval.current);
      setResult((prev) => ({ ...prev, ...webSocketResult }));
      console.log("webSocketResult", webSocketResult);
    } else {
      clearInterval(interval.current);
      interval.current = setInterval(() => {
        httpStateQuery(cryptoPair?.toUpperCase(), klineInterval.server).then(
          ({ data }) => {
            console.log(data);
            const res = {
              time: 0,
              open: 0,
              close: 0,
              high: 0,
              low: 0,
              volume: 0,
            };
            if (data.data.length > 0) {
              res.time = data.data[0][0];
              res.open = data.data[0][1];
              res.close = data.data[0][2];
              res.high = data.data[0][3];
              res.low = data.data[0][4];
              res.volume = data.data[0][5];
            }
            setResult(res);
          }
        );
      }, 2000);
    }
    return () => pingPong && shouldUseWebSocket && clearInterval(interval.current);
  }, [pingPong, shouldUseWebSocket, webSocketResult, klineInterval, cryptoPair]);

  // اطلاعات هر کندل رو مجزا بهمون میده
  return result;
};
export default useStateQuery;
